import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="m17.254 21.673-4.616-2.427a1.38 1.38 0 0 0-1.276 0l-4.617 2.428a1.28 1.28 0 0 1-1.42-.15 1.27 1.27 0 0 1-.438-1.204l.88-5.136a1.37 1.37 0 0 0-.395-1.215l-3.735-3.636a1.28 1.28 0 0 1-.36-1.192 1.275 1.275 0 0 1 1.072-.994l5.162-.755a1.37 1.37 0 0 0 1.032-.75l2.31-4.68c.23-.466.69-.713 1.147-.712.462 0 .924.253 1.149.716l2.31 4.676c.198.404.584.684 1.03.75l5.165.756c.575.083.977.53 1.076 1.032.08.4-.042.836-.368 1.152l-3.735 3.637c-.323.315-.47.77-.394 1.214l.881 5.14c.086.486-.099.943-.437 1.216a1.31 1.31 0 0 1-1.423.134" />
  </>
);

const StarFilled = Icon('star-filled', svgContents);

export default StarFilled;
